import React from 'react';

/* eslint-disable */
const DisplayInfoMessage: React.FC<any> = ({ displayMessage }) => {
  return (
    <div>
      {displayMessage.message !== '' && (
        <div
          className={`m-3 ${
            displayMessage.error ? 'text-red-500' : 'text-green-500'
          }`}
        >
          {String.raw` ${displayMessage.message}`}
        </div>
      )}
    </div>
  );
};
export default DisplayInfoMessage;
